import z from "zod";
import { Currencies } from "../settings/tasa-schema";

export const CurrencyConfig = z
  .object({
    // La moneda en la que el dueño ve sus reportes y balances
    accountingCurrency: Currencies.default('USD'),
    localCurrency: Currencies.default('BS'),
    multiCurrency: z.boolean().default(true),
    ratePolicy: z.literal('official').default('official'),
  })
  .default({
    accountingCurrency: 'USD',
    ratePolicy: 'official',
    localCurrency: 'BS',
    multiCurrency: true,
  });
